import React from 'react';

import { httpServices } from '../../../../services/httpServices';
import { DisabilityDetailsComponent } from "./Disability.Component";

const formFields = {
    'id':0,
    'disability_type': null,
    'start_date': null,
    'end_date': null,
};

export class DisabilityDetails extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            disabilityDetails : [],
            open : false,
            formFields : formFields,
            errors : {},
            IsEditable : false,
        };
        this.onAdd = this.onAdd.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    onAdd = () => {        
        if(this.state.disabilityDetails.length < 1 && this.props.disabilityDetails){
            this.setState({disabilityDetails : this.props.disabilityDetails});
        }
        let formFields = {
            'id':0,
            'disability_type': null,
            'start_date': null,
            'end_date': null,
        };
        this.setState({
            open : true,
            IsEditable: false,
            formFields : formFields,
        });
    };

    onClose = () => {
        this.setState({
            open : false,
            errors : {}
        });
    };
   
    handleOnChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.formFields;
        ff[field] = evt.target.value;
        this.setState({
            formFields : ff
        });
    };

    handleSubmit = (event) => {
        if(this.handleValidation()){
            let data = this.state.formFields;
            if (data) {
                data.staff_id = this.props.staffId; 
                httpServices.post('api/staff/personal/saveDisabilityDetails', { data })
                    .then(response => {
                        if (!response.data.errors) {
                            if (response.data.status) {
                                if(response.data.start_date || response.data.end_date){
                                    data['start_date'] = response.data.start_date;
                                    data['end_date'] = response.data.end_date;
                                }
                                let disability_type_text  = this.getDisabilityTypeById(data.disability_type);
                                if(disability_type_text){
                                    data['title'] = disability_type_text;
                                }
                                if(data.id){
                                    const index = this.state.disabilityDetails.findIndex(dd => dd.id === data.id);
                                    let disability_details = this.state.disabilityDetails;
                                    disability_details[index] = data;
                                    this.setState({disabilityDetails : disability_details,open: false});
                                    alert("Disability details updated successfully");
                                } else { 
                                    let disability_details = this.state.disabilityDetails;
                                    data['id'] = response.data.id;
                                    disability_details.push(data);
                                    this.setState({
                                        disabilityDetails : disability_details,
                                        open : false,
                                    });
                                    alert("Disability details saved successfully");
                                }        
                            } else {
                                alert(response.data.msg);
                            }
                        }
                        else {
                            this.setState({errors : response.data.errors});
                        }
                    })
                    .catch(function(error) {
                        console.log("error" + error);
                    });
            }
        }
    };

    onUpdate = (id) => () => {
        if(this.state.disabilityDetails.length < 1 && this.props.disabilityDetails){
            this.setState({disabilityDetails : this.props.disabilityDetails});
        }
        if(id){
            httpServices.post('api/staff/personal/getDisabilityDetailsById', { id : id })
                .then(response => {
                    let disability_details = response.data.disability_details;
                    if(disability_details){
                        this.setState({
                            open : true,
                            formFields : disability_details,
                            IsEditable : true,
                        });
                     }
                })
                .catch(function(error) {
                    console.log("error" + error);
                });
        }
    };

    onDeleteSubmit = (id) => () => {
        if (id) {
            let confirm_delete = window.confirm("Do you want to delete this entry");
            if(confirm_delete){
                if(this.state.disabilityDetails.length < 1 && this.props.disabilityDetails){
                    this.setState({disabilityDetails : this.props.disabilityDetails});
                }
                let data = {
                    id : id,
                    staff_id : this.props.StaffID
                };
                httpServices.post('api/staff/personal/deleteDisabilityDetails', { data })
                    .then(response => {
                        const index = this.state.disabilityDetails.findIndex(dd => dd.id === data.id);
                        let disability_details = this.state.disabilityDetails;
                        disability_details.splice(index,1);
                        this.setState({disabilityDetails : disability_details,open: false});
                        alert("Disability details deleted successfully");
                    })
                    .catch(function(error) {
                        console.log("error" + error);
                    });
            }
        }
    };

    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (!this.state.formFields.start_date) {
            errors["start_date"] = "Cannot be empty";
            formIsValid = false;
        }
        if (!this.state.formFields.disability_type) {
            errors["disability_type"] = "Cannot be empty";
            formIsValid = false;
        }
        let start_date = this.state.formFields.start_date ? new Date(this.state.formFields.start_date) : this.state.formFields.start_date;
        let end_date = this.state.formFields.end_date ? new Date(this.state.formFields.end_date) : this.state.formFields.end_date;
        if ( start_date && end_date ) {
            if(end_date < start_date){
                errors["end_date"] = "Please enter a valid End Date";
                formIsValid = false;
            }
        }
        this.setState({errors : errors});
        return formIsValid;
    }

    getDisabilityTypeById = (id) => {
        if(this.props.formInputs.disability_types){
            let title = '';
            let disability_types = this.props.formInputs.disability_types;
            disability_types.forEach(function(item){
                if(item.id === id){
                    title = item.title;
                }
            });
            return title;
        }
    };

    handleDateChange = (value, name) => {
        const ff = this.state.formFields;
        ff[name] = value;
        this.setState({
            formFields : ff
        });
    };

    render(){
        return (
            <DisabilityDetailsComponent 
                disabilityDetails = { this.state.disabilityDetails.length > 0 ? this.state.disabilityDetails : this.props.disabilityDetails }
                open = { this.state.open }
                onAdd = { this.onAdd }
                FormFields = { this.state.formFields } 
                Errors = { this.state.errors }
                HandleOnChange = { this.handleOnChange }
                onClose = { this.onClose }
                FormInputs = { this.props.formInputs }
                OnSubmit = { this.handleSubmit }
                staffId = { this.props.staffId }
                onUpdate = { this.onUpdate }
                onDeleteSubmit = { this.onDeleteSubmit }
                IsEditable = { this.state.IsEditable }
                EditPermission = { this.props.Edit }
                DeletePermission = { this.props.Delete }
                HandleDateChange = {this.handleDateChange}
            />
        )
    }
}
